import { render, staticRenderFns } from "./RouteCreate.vue?vue&type=template&id=2bb65e59"
import script from "./RouteCreate.vue?vue&type=script&lang=js"
export * from "./RouteCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports